<template>
  <div class="">
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("Alias") }}</label>
            <b-form-input
                v-model="filter.like.alias"
                class="d-inline-block mr-1"
            />
          </b-col>

          <b-col cols="12" md="9" class="">

            <b-form-group :label="msg('Real estate')" label-for="realEstate-branch">
              <real-estate-picker multiple clearable v-model="filter.in.propertyIds"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <div class="card-header" style="overflow: hidden">
        <i class="fas fa-directions" style="margin-right: 3px"></i>

        <span class="card-title m-0">{{ msg('Guidelines') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>
      <!--Card Content-->
      <b-card-body>
        <div class="">
          <!-- Table Top -->
          <b-row no-gutters class="mb-1">
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ msg('Show') }}</label>
              <v-select
                  v-model="page.amount"
                  :options="[10, 25, 50, 100]"
                  :clearable="false"
                  @option:selected="refresh"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ msg('entries') }}</label>
            </b-col>
            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <span class="mr-1"></span>
                <b-button variant="primary" @click="onNewGuideline(0)">
                  <i class="fas fa-directions" style="margin-right: 2px"></i>

                  <span class="text-nowrap">{{ msg('New Guideline') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>
        <!--Table-->
        <b-table
            ref="guideline-table"
            striped
            hover
            responsive
            v-bind:items="guidelines"
            v-bind:fields="fields"
            :busy="loading"
            @sort-changed="onSort"
            @row-clicked="onRowClick"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mx-1"></b-spinner>
              <strong>{{ msg('Loading') }}...</strong>
            </div>
          </template>

          <template #cell(buid)="data">
            {{ getBranchName(data.value) }}
          </template>

          <template #cell(creationDate)="data">
            {{ $moment(data.value, 'YYYY-MM-DD HH:mm').format("DD/MM/YY HH:mm") }}
          </template>

          <template #cell(propertyIds)="data">
            <div>
              <b-button
                  size="sm"
                  variant="link"
                  @click="toggleVisibleRow(data.index)"
                  class="p-0"
              >
                {{ visibleRows[data.index] ? 'Hide' : 'Show' }} {{ msg('Properties') }} ({{ data.value.length }})
              </b-button>

              <b-collapse :id="'property-collapse-' + data.index" :visible="visibleRows[data.index]">
                <ul class="mt-2 mb-0 pl-3">
                  <li
                      v-for="propertyId in data.value"
                      :key="propertyId"
                      style="white-space: nowrap;"
                  >
                    {{ realEstates[propertyId].name || propertyId }}
                  </li>
                </ul>
              </b-collapse>
            </div>
          </template>


          <template #cell(actions)="row">
            <b-button
                size="sm"
                @click="openConfirmationModal('delete', row.item)"
                class="btn btn-danger mr-1"
                v-b-tooltip.hover
                :title="msg('Delete')"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
          </template>


        </b-table>

        <!--Table Paginator-->
        <div class="text-center w-100">
          <div class="d-inline-block">
            <b-pagination
                v-model="page.currentPage"
                :total-rows="page.total"
                :per-page="page.amount"
                first-number
                last-number
                @input="refresh"
            />
          </div>
          <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
        </div>
      </b-card-body>
    </b-card>
    <b-modal no-fade v-model="dialogs.newGuideline" size="lg" ref="guideline-modal" id="guideline-modal"
             :hide-footer="true" no-close-on-backdrop centered>
      <guideline-panel ref="guidelinePanel" @submitted="onSubmitted"/>
    </b-modal>
    <b-modal no-fade v-model="dialogs.updateGuideline" size="lg" ref="guideline-mofddal" id="roudfter-modal"
             :hide-footer="true" no-close-on-backdrop centered>
      <edit-guideline-panel ref="routefdrPanel" @submitted="onSubmitted" :id="selected"/>
    </b-modal>

    <b-modal
        v-model="showConfirmationModal"
        :title="msg('Confirm Action')"
        @cancel="closeModal"
        centered
        :cancel-title="msg('Cancel')"
        ok-variant="success"
        cancel-variant="danger"
        @ok="confirmAction"
    >
      <div>
        <p>{{ modalMessage }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import GuidelinePanel from "./guidelinePanel.vue";
import EditGuidelinePanel from "@/views/realEstate/guidelines/editGuidelinePanel.vue";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker.vue";

export default {
  name: 'Guidelines',
  components: {RealEstatePicker, GuidelinePanel, EditGuidelinePanel},
  data() {
    return {
      loading: true,
      showConfirmationModal: false,
      modalEvent: '', // To store the event type (e.g., 'charge', 'delete', etc.)
      modalMessage: '', // The dynamic message based on the event type
      selectedItem: null, // The item being acted upon
      visibleRows: {},

      amount: 10,
      guidelines: [],
      fields: [],
      selected: null,
      realEstates: {},

      filter: {
        like: {search: ''},
        eq: {},
        lte: {},
        gte: {},
        in: {status: []}
      },
      sort: {
        by: 'creationDate',
        desc: true,
        direction: 'desc'
      },
      statusVariants: {

        "online": "success",
        "offline": "secondary",
        "inProgress": "warning",
        "error": "danger"
      },


      page: {
        amount: 10,
        currentPage: 1,
        total: 0
      },
      dialogs: {newGuideline: false, updateGuideline: false},
      //Listeners
      listeners: {
        refresh: () => {
        }
      }

    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh()
      }
    },
    file: {
      handler() {
      }
    }
  },
  computed: {
    ...mapGetters('data', ['getOrganizationWebSite', 'getRealEstatesWebSite']),
    ...mapGetters('data', ['getUserFullName', 'getUserAcronyms']),
    ...mapGetters('data', ['getAllUsers', 'getUsersInTeam', 'getUserRole', 'getRoles', 'getRoleName']),
    ...mapGetters('translator', ['msg']),
    ...mapGetters('guideline', ['allGuidelineStatus']),
    ...mapGetters('data', ['getBranchName']),

    guidelineStatus() {
      let $this = this;
      return this.allGuidelineStatus.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },
  },
  created() {
    let $this = this;
    this.setFields();
    this.refresh()
    this.$root.$on('crm::branch-updated', (this.listeners.refresh = () => {
      $this.refresh()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::branch-updated', this.listeners.refresh)
  },
  methods: {
    ...mapActions('guideline', ['getAllGuidelines', 'copySuccess','deleteService']),
    ...mapActions('clients', ['getClients']),
    toggleVisibleRow(index) {
      this.$set(this.visibleRows, index, !this.visibleRows[index]);
    },
    openConfirmationModal(event, item) {
      // Set the event type and selected item
      this.modalEvent = event;
      this.selectedItem = item;
      // Dynamically set the message based on the event
      if (event === 'delete') {
        this.modalMessage = this.msg('Are you sure you want to delete this service?');
      }

      // Show the confirmation modal
      this.showConfirmationModal = true;
    },
    closeModal() {
      // Close the confirmation modal
      this.showConfirmationModal = false;
    },
    confirmAction() {
      // Call the actual function based on the event
      if (this.modalEvent === 'delete') {
        this.handleEvent('delete', this.selectedItem);
      }
      // Close the modal after action
      this.closeModal();
    },
    handleEvent(event,item) {
      let $this = this;
      this.deleteService({id: item.id}).then(() => $this.refresh())
    },
    getContractTypeLabel(value) {
      const contract = this.contractTypes.find(item => item.value === value);
      return contract ? contract.text : value; // Return the label or the value if not found
    },
    routeToProperty(propertyId) {
      window.open(`/real_estate/edit/${propertyId}`, '_blank');
    },
    onCopy: function (e) {
      this.copySuccess(e.text)
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
    },

    setFields() {
      let $this = this;

      this.fields = [
        {
          key: 'alias',
          label: $this.msg('alias'),
          sortable: false
        },
        {
          key: 'buid',
          label: $this.msg('branch'),
          sortable: true
        } ,{
          key: 'propertyIds',
          label: $this.msg('realEstates'),
          sortable: true
        } ,{
          key: 'creationDate',
          label: $this.msg('creationDate'),
          sortable: true
        }
      ];
    },

    copyId(id) {
      console.log("the id copied was: ", id)
    },

    refresh() {
      let $this = this
      this.loading = true;
      this.sort = {
        by: 'creationDate',
        desc: true,
        direction: 'desc'
      },
          this.getAllGuidelines({
            page: $this.page.currentPage,
            amount: $this.page.amount,
            filter: $this.filter,
            sortcolumn: $this.sort.by,
            sortby: $this.sort.direction,
          }).then(this.onGuidelinesRetrieve, (error) => $this.error = error)

    },
    onGuidelinesRetrieve(data) {
      this.page = {
        amount: data['Amount'],
        total: data['Total'],
        currentPage: data['Page']
      };
      this.sort = {
        by: data["sortColumn"],
        direction: data["sortOrder"]
      }
      this.guidelines = data["Guidelines"];
      this.realEstates = data["RealEstates"].reduce((map, realEstate) => {
        if (realEstate.id) {
          map[realEstate.id] = realEstate;
        }
        return map;
      }, {});
      this.loading = false;
    },

    onNewGuideline(id) {

      this.dialogs.newGuideline = true

    },
    onSort(data) {
      this.sort.by = data.sortBy;
      this.sort.direction = data.sortDesc ? "desc" : "asc";
      this.refresh();
    },
    onRowClick(guideline) {
      this.selected = guideline.id;
      this.dialogs.updateGuideline = true
    },

    onSubmitted(server) {
      if (server.id != null)
        this.selected = server.id;
      this.refresh()
      this.dialogs.newGuideline = false;
      this.dialogs.updateGuideline = false;
    },
    onClientSelect(clientId) {
      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('crm::client::select', clientId)
    },
  }
}
</script>

<style>
ul {
  list-style-type: disc;
  padding-left: 1rem;
}

</style>
